// extracted by mini-css-extract-plugin
export default {"root":"section-title_root__0+Wlo"};